import React from "react";
import { Controller } from "react-hook-form";
import { FontEnum } from "../../utils/enums/FontEnum";

const ControllerTextArea = ({
    name,
    control,
    defaultValue,
    placeholder,
    disabled = false,
    width = 250,
    height = 300,
    onChange,
    styleForTextArea = {},
}) => {

    const getStyle = () => {
        return {
            ...styles.inputStyle,
            width,
            height,
            ...styleForTextArea,
        }
    }

    return (
        <Controller
            name={name}
            defaultValue={defaultValue || ""}
            control={control}
            render={({ field, fieldState }) => (
                <textarea
                    {...field}
                    id={name}
                    style={getStyle()}
                    placeholder={placeholder ?? ""}
                    disabled={disabled}
                    onChange={(e) => {
                        field.onChange(e);
                        if (onChange) {
                            onChange(e);
                        }
                    }}
                />
            )}
        />
    );
};

export default ControllerTextArea;

const styles = {
    inputStyle: {
        minHeight: 150,
        paddingTop: 10,
        backgroundColor: 'transparent',
        border: "1px solid #0000003b",
        borderRadius: 6,
        paddingInline: 12,
        fontFamily: FontEnum.TITILIUM_WEB,
    }
}
